import { useParams } from 'react-router-dom'

import { useCitationHistoryDetailApi } from '@/common/api/modules/citation'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import CitationResultView from '@/components/container/modules/mediaGeo/citation/CitationResultView'

import MediaAnalysisResultPageBase from './MediaAnalysisResultPageBase'

// サイテーション分析結果（GEO/LLMO）
const MediaAnalysisCitationResultPage = () => {
  const { siteId, historyId } = useParams()
  const sid = Number(siteId)
  // 分析中（status=analyzing）の間は2秒間隔でポーリングし、完了したら自動的に停止する
  const { data, error } = useCitationHistoryDetailApi(
    siteId && historyId ? { site_id: sid, history_id: Number(historyId) } : undefined,
    { refreshInterval: (latest) => (latest?.status === 'analyzing' ? 2000 : 0) }
  )

  return (
    <MediaAnalysisResultPageBase
      type={MediaAnalysisType.CITATION}
      data={data}
      error={error}
      resultError={data?.result?.error}
    >
      {data?.result && (
        <CitationResultView result={data.result} siteId={sid} historyId={Number(historyId)} />
      )}
    </MediaAnalysisResultPageBase>
  )
}

export default MediaAnalysisCitationResultPage
